import {
  curry, filter, isNil, startsWith,
} from 'ramda';

export default curry((langs, defaultLangKey, langKey) => {
  if (isNil(langKey)) return defaultLangKey;
  const currentLangKey = filter((l) => startsWith(l, langKey), langs);
  return currentLangKey[0] || defaultLangKey;
});
